import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {reducers} from './syncReducers'
import { PlanningState } from "./interfaces";

const initialState: PlanningState = {
    planingTask: []
}

export const planningSlice = createSlice({
  name: "planning",
  initialState,
  reducers,
});